<obg-session-timer-container [timerText]="'timer.session.text'"></obg-session-timer-container>
